import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { NFIntInput } from "src/components/Shared/NewForms/NFIntInput";
import { NFLookupAccount } from "src/components/Shared/NewForms/NFLookupAccount";
import { NFLookupProduct } from "src/components/Shared/NewForms/NFLookupProduct";
import { NFLookupUnit } from "src/components/Shared/NewForms/NFLookupUnit";
import { NFPlainNumber } from "src/components/Shared/NewForms/NFPlainNumber";
import { NFPlainText } from "src/components/Shared/NewForms/NFPlainText";
import { NFormTable } from "src/components/Shared/NewForms/NFormTable";
import { ProductTypeEnum } from "src/enums/Products/ProductTypeEnum";
import { VatTypeEnum } from "src/enums/VatTypeEnum";
import { AmountHelper } from "src/helpers/AmountHelper";
import { DocumentCalculationsHelper } from "src/helpers/DocumentCalculationsHelper";

export const OpenBalanceOfGoodsDetailProducts = () => {
  const tableName = "products";
  const { setValue, getValues } = useFormContext();
  const { t } = useTranslation();

  const handleVatTypeChanged = (newVatType: VatTypeEnum, index: number) => {
    setValue(`${tableName}.${index}.vatAmount`, AmountHelper.getVatAmount(newVatType, getValues(`${tableName}.${index}.amount`), getValues("priceIncludesVat")));
  };

  const handleQuantityChanged = (newQuantity: number, index: number) => {
    const newAmounts = AmountHelper.getNewAmountsAfterQuantityPriceChanged(
      newQuantity,
      getValues(`${tableName}.${index}.price`),
      getValues(`${tableName}.${index}.vatType`),
      getValues("priceIncludesVat")
    );
    setValue(`${tableName}.${index}.amount`, newAmounts.amount);
    setValue(`${tableName}.${index}.vatAmount`, newAmounts.vatAmount);
    setValue(`${tableName}.${index}.amountWithVat`, newAmounts.amountWithVat);
  };

  const handlePriceChanged = (newPrice: number, index: number) => {
    const newAmounts = AmountHelper.getNewAmountsAfterQuantityPriceChanged(
      getValues(`${tableName}.${index}.quantity`),
      newPrice,
      getValues(`${tableName}.${index}.vatType`),
      getValues("priceIncludesVat")
    );
    setValue(`${tableName}.${index}.amount`, newAmounts.amount);
    setValue(`${tableName}.${index}.vatAmount`, newAmounts.vatAmount);
    setValue(`${tableName}.${index}.amountWithVat`, newAmounts.amountWithVat);
  };

  const handleAmountChanged = () => {
    setValue("totalAmount", DocumentCalculationsHelper.calculateTotalAmount(getValues("products"), "amount"));
  };

  return (
    <>
      <NFormTable fieldArray={tableName}>
        <NFPlainNumber fieldName={"lineNo"} title={t("#")} width={50} />
        <NFLookupProduct fieldName={"productId"} title={t("Product")} modelField={"productModel"} required={true} productType={ProductTypeEnum.Product} />
        <NFPlainText fieldName={"vendorCode"} modelField={"productModel"} title={t("VendorCode")} width={80} />
        <NFLookupUnit fieldName={"unitId"} title={t("Unit")} width={200} />
        <NFIntInput fieldName={"quantity"} title={t("Quantity")} onValueChanged={handleQuantityChanged} />
        <NFIntInput fieldName={"price"} title={t("Price")} onValueChanged={handlePriceChanged} />
        <NFIntInput fieldName={"amount"} title={t("Amount")} onValueChanged={handleAmountChanged} />
        <NFLookupAccount fieldName={"accountId"} title={t("Account")} />
      </NFormTable>
    </>
  );
};
